import {
  GeneralSettingSubmitForm,
  SmtpSubmitForm,
  SupportUserSubmitForm,
} from "models/generalSetting";
import { ApiResponse } from "models";
import axiosClient from "./axiosClient";
import { ImageUrlData } from "models";

const generalSettingApi = {
  getGeneralDetail(): Promise<GeneralSettingSubmitForm> {
    const url = `/generalSettingAdmin/getGeneralDetails`;
    return axiosClient.get(url);
  },

  getSMTPDetail(): Promise<SmtpSubmitForm> {
    const url = `/generalSettingAdmin/getSmtpDetails`;
    return axiosClient.get(url);
  },

  getSupportUserDetail(): Promise<SupportUserSubmitForm> {
    const url = `/generalSettingAdmin/getCustomerSupportDetails`;
    return axiosClient.get(url);
  },

  addGeneralDetails(data: GeneralSettingSubmitForm): Promise<ApiResponse> {
    const url = `/generalSettingAdmin/addGeneralDetails`;
    return axiosClient.post(url, data);
  },

  addSMTPDetails(data: SmtpSubmitForm): Promise<ApiResponse> {
    const url = `/generalSettingAdmin/addSmtpDetails`;
    return axiosClient.post(url, data);
  },

  addCustomerDetails(data: SupportUserSubmitForm): Promise<ApiResponse> {
    const url = `/generalSettingAdmin/addCustomerSupportDetails`;
    return axiosClient.post(url, data);
  },

  getImageUrl(data: ImageUrlData): Promise<ApiResponse> {
    const url = `/settings/uploadImage`;
    return axiosClient.post(url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};

export default generalSettingApi;
